import TRow from "./TRow";

const TBody = ({ data }) => {
  return (
    <>
      {data.map((doc) => (
        <TRow key={doc.id || doc._id} doc={doc} />
      ))}
    </>
  );
};

export default TBody;
